import { AlertTriangle } from "lucide-react";

const ErrorFallback = () => {
  return (
    <div className="min-h-screen bg-warm-bg-base flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-5">
          <div className="w-14 h-14 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
            <AlertTriangle className="w-7 h-7 text-amber-600 dark:text-amber-400" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-warm-text-primary mb-2">
          Something went wrong
        </h1>
        <p className="text-warm-text-secondary mb-6">
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="inline-block px-6 py-3 bg-warm-blue text-white rounded-lg hover:opacity-90 transition-opacity font-medium"
        >
          Refresh page
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
